import { FixedSubEntityImportSheetInfo, SubEntityForecastParams } from '../../import/types';

/**
 * Converts the input data to data that can be used with sheets hooks
 * @param workspaceId - Workspace ID
 * @param sheetInfo - sub_entity_import_sheet_info data from the consolidated forecast
 */
export const convertToSubEntityForecastParams = (
  workspaceId: string,
  sheetInfo?: FixedSubEntityImportSheetInfo
): SubEntityForecastParams[] => {
  if (sheetInfo) {
    return Object.keys(sheetInfo)
      .filter(entityId => !!sheetInfo[entityId].import_sheet_id)
      .map(entityId => ({
        workspaceId,
        organisationId: entityId,
        forecastId: sheetInfo[entityId].sub_forecast_id,
        sheetId: sheetInfo[entityId].import_sheet_id as string,
        hasCreatedImportSheet: !!sheetInfo[entityId].import_sheet_id
      }));
  }
  return [];
};
